<template>
    <a href="/cart">
        <div class="carticon"><span class="badge badge-danger shoppingcount">{{ getCartCount() }}</span></div>
    </a>
</template>

<script>
    import { ServiceFactory } from '../assets/js/services/ServiceFactory';

    const CartService = ServiceFactory.get('cart');

    export default {
        props: ['count'],

        created() {
            this.setCartCount(this.count);
            this.refresh();
        },

        methods: {
            getCartCount() {
                return this.$store.getters.cartCount;
            },

            setCartCount(cartCount) {
                this.$store.commit('setCartCount', cartCount);
            },

            async refresh() {
                const request = await CartService.get();
                let data = request.data;
                if (data) {
                    let count = 0;
                    for(const [key, value] of Object.entries(data)) {
                        let quantity = Number.parseInt(value.qty);
                        if(quantity && quantity > 0) {
                            count += quantity;
                        }
                    }
                    this.setCartCount(count);
                }
            },
        }

    }
</script>
